import styled from 'styled-components';
import { DownCaratIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DropdownButton(props) {
  return /*#__PURE__*/_jsxs(Button, Object.assign({}, props, {
    children: [props.children, /*#__PURE__*/_jsx(SmallDownCaret, {})]
  }));
}
const IconShrinker = styled.div.withConfig({
  displayName: "DropdownButton__IconShrinker",
  componentId: "pvtvw3-0"
})(["margin-top:-1px;svg{height:7px !important;width:7px !important;inline-size:7px !important;block-size:7px !important;}"]);
export function SmallDownCaret() {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(IconShrinker, {
      children: /*#__PURE__*/_jsx(DownCaratIcon, {
        size: "inherit"
      })
    })
  );
}